import { t } from "@/i18n-js/instance";
import { Typography } from "@circle-react-uikit/Typography";
import { BillingDetailsContainer } from "./BillingDetailsContainer";

export const Addons = () => (
  <BillingDetailsContainer>
    <Typography.LabelLg>
      {t("settings.billing.manage_billing.addons.title")}
    </Typography.LabelLg>
  </BillingDetailsContainer>
);
